import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as LikeSvg } from './assets/like.svg';

const LikeIcon = React.forwardRef((args, ref) => <SvgIcon component={LikeSvg} ref={ref} {...args} />);

export default LikeIcon;
